import { render, staticRenderFns } from "./SubjectTemplateItemback.vue?vue&type=template&id=93dfafa0&scoped=true"
import script from "./SubjectTemplateItemback.vue?vue&type=script&lang=js"
export * from "./SubjectTemplateItemback.vue?vue&type=script&lang=js"
import style0 from "./SubjectTemplateItemback.vue?vue&type=style&index=0&id=93dfafa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dfafa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93dfafa0')) {
      api.createRecord('93dfafa0', component.options)
    } else {
      api.reload('93dfafa0', component.options)
    }
    module.hot.accept("./SubjectTemplateItemback.vue?vue&type=template&id=93dfafa0&scoped=true", function () {
      api.rerender('93dfafa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/preSubject/SubjectTemplateItemback.vue"
export default component.exports